import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import Link from 'components/Link';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Cookie from 'utils/cookies';
import s from './PracticeCard.scss';
import { TOI_LIVE_DOMAIN, TOI_IMAGE_DOMAIN } from '../../../../../constants';
import Image from '../../../../../components/Image';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';

const PracticeCard = props => {
  const {
    gameType,
    apiConfigData,
    isLargeCard,
    ga4Category,
    isMobile,
    gameId,
    pageTemplate,
    gameLevel,
  } = props;
  let grxId = Cookie.get('_grx');
  let ssoId = Cookie.get('ssoid');
  grxId = grxId || '';
  ssoId = ssoId || '';

  const getImageUrl = () => {
    const apiGameType = gameType?.replace(/-/g, '_');
    if (
      apiConfigData &&
      apiConfigData[apiGameType] &&
      apiConfigData[apiGameType].listingIconUrl &&
      apiConfigData[apiGameType].listingIconUrl.imageUrl
    ) {
      return apiConfigData[apiGameType].listingIconUrl.imageUrl;
    }
    return `${TOI_IMAGE_DOMAIN}/photo/113254487.cms`;
  };

  return (
    <InViewObserver
      inViewCallback={() => {
        const gaData = {
          event: 'user_shown_games',
          type: 'game_practice_widget',
          page_template: pageTemplate || 'gameplay',
          section: 'games',
          subsection:
            gameType === 'loop-a-loop'
              ? 'loop_the_loop'
              : gameType?.replace(/-/g, '_'),
          browsing_platform: isMobile ? 'mweb' : 'web',
          level: gameLevel || 'N/A',
          game_of_the_day: window.location.href
            .toLowerCase()
            .includes('/today'),
          login_status: !!ssoId,
          user_grx_id: grxId,
        };
        if (ga4Category) {
          gaData.category = ga4Category;
        }
        if (ssoId) {
          gaData.sso_id = ssoId;
        }
        if (gameId) {
          gaData.game_id = gameId;
        }
        analyticsWrapper('ga4', gaData);
        analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
      }}
    >
      <div className={`${s.previousGameCardWrapper}`}>
        <Link
          className={`${s.previousGameCard} ${s.br16} ${
            isLargeCard ? s.previousGameCardLarge : ''
          }`}
          to={`${TOI_LIVE_DOMAIN}/games/${gameType.replace(
            /_/g,
            '-',
          )}/practice`}
          onClick={() => {
            const gaData = {
              event: 'user_click_games',
              type: 'game_parctice_widget',
              page_template: pageTemplate || 'gameplay',
              section: 'games',
              subsection:
                gameType === 'loop-a-loop'
                  ? 'loop_the_loop'
                  : gameType?.replace(/-/g, '_'),
              browsing_platform: isMobile ? 'mweb' : 'web',
              level: gameLevel || 'N/A',
              game_of_the_day: window.location.href
                .toLowerCase()
                .includes('/today'),
              login_status: !!ssoId,
              user_grx_id: grxId,
            };
            if (ga4Category) {
              gaData.category = ga4Category;
            }
            if (ssoId) {
              gaData.sso_id = ssoId;
            }
            if (gameId) {
              gaData.game_id = gameId;
            }
            analyticsWrapper('ga4', gaData);
            analyticsWrapper('grx', 'track', 'user_click_games', gaData);
          }}
        >
          <div className={s.contentArea}>
            <figure>
              <Image
                src={getImageUrl()}
                placeHolderSrc={`${TOI_IMAGE_DOMAIN}/photo/111258810.cms`}
                alt="Practice"
                lazyload
                offsetVertical={200}
              />
            </figure>
            {(() => {
              if (gameType === 'location-guesser') {
                return <strong>Play more from the archives</strong>;
              } else if (gameType === 'whos-that') {
                return <strong>Practice more games</strong>;
              }
              return <strong>Practice more puzzles</strong>;
            })()}
          </div>
          {/* <Link
          </div>
          {/* <Link
          to={`${TOI_LIVE_DOMAIN}/games/${gameType}/practice`}
          className={`${s.btnPrimary} ${s.btnSecondary}`}
        >
          Practice Now
        </Link> */}
        </Link>
      </div>
    </InViewObserver>
  );
};

const mapStateToProps = state => ({
  apiConfigData: _get(state, 'toigames.gamesconfig.gameCategories', {}),
  isMobile: _get(state, 'isMobile', false),
});

export default connect(mapStateToProps)(PracticeCard);
